import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionContainer from './SectionContainer';
import SectionEyebrow from './SectionEyebrow';

const FounderSection = () => (
  <Box sx={{ bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(37,99,235,0.08)' : '#F7F9FF'), py: { xs: 6, md: 8 } }}>
    <SectionContainer>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <SectionEyebrow>From the Founder</SectionEyebrow>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          gap: { xs: 2.5, sm: 4 },
          maxWidth: 720,
          mx: 'auto',
          textAlign: { xs: 'center', sm: 'left' },
        }}
      >
        <Box
          component="img"
          src="/rohit.jpg"
          alt="Rohit Rana, Founder of Remembr"
          sx={{
            width: { xs: 96, sm: 120 },
            height: { xs: 96, sm: 120 },
            borderRadius: '50%',
            objectFit: 'cover',
            flexShrink: 0,
            border: '3px solid',
            borderColor: 'background.paper',
            boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
          }}
        />
        <Box>
          <Typography sx={{ color: 'text.secondary', fontSize: { xs: 15, md: 16.5 }, lineHeight: 1.7, mb: 2 }}>
            &ldquo;Hi, I&apos;m Rohit. I built Remembr because I kept struggling to recall when I last changed a
            part and how much I paid for it. Remembr is my attempt at remembering the details that matter, so I
            can make smarter decisions the next time around.&rdquo;
          </Typography>
          <Typography sx={{ fontWeight: 700, fontSize: 15 }}>Rohit Rana</Typography>
          <Typography sx={{ color: 'text.secondary', fontSize: 13.5 }}>Founder of Remembr &amp; Arrayscript</Typography>
        </Box>
      </Box>
    </SectionContainer>
  </Box>
);

export default FounderSection;
